import { Injectable } from '@angular/core';
import { DatePreset } from '../constants/date-preset.enum';
import { presetDurations } from '../constants/preset-durations';

@Injectable({
  providedIn: 'root',
})
export class DatePresetService {
  static getDateRange(preset: DatePreset): { from: Date; to: Date } {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Handle Tomorrow preset specially - start from tomorrow, not today
    if (preset === DatePreset.Tomorrow) {
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);

      return { from: new Date(tomorrow), to: new Date(tomorrow) };
    }

    // For all other presets, start from today
    const from = new Date(today);
    const to = new Date(today);
    const daysToAdd = presetDurations[preset] ?? 0;

    to.setDate(today.getDate() + daysToAdd);

    return { from, to };
  }
}
